<header class="page-header">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6 col-lg-4">
        <a href="index.html" title="{{this.userUtilsService.selectedEnvironment?.Name}} PPRA" class="logo">
          <img [src]="this.userUtilsService.selectedEnvironment?.src" height="75"
            [alt]="this.userUtilsService.selectedEnvironment?.alt" class="mr-3">
          <h1>{{this.userUtilsService.selectedEnvironment?.Name}} Public Procurement Regulatory
            Authority<br><small class="text-body">Government of
              {{this.userUtilsService.selectedEnvironment.key == 1 ? 'Pakistan':
              this.userUtilsService.selectedEnvironment?.Name}}</small></h1>
          <!-- <h5 class="text-body text-right d-none d-lg-block urdu mb-0">وفاقی پبلک پروکیورمنٹ ریگولیٹری اتھارٹی
                        حکومت پاکستان</h5> -->
        </a>
      </div>
      <div class="col-md-6 col-lg-8 d-flex flex-row align-items-center justify-content-end">
        <h5 class="text-body text-right d-none d-lg-block urdu mb-0 mr-4">وفاقی پبلک پروکیورمنٹ ریگولیٹری <br>اتھارٹی
          حکومت پاکستان</h5>
        <ul class="account_section">
          <!-- <li class="text_12">{{CurentDate | date}}</li>
					<li>UAN: <a href="tel:051111137237" class="text-dark font-weight-bold">051-111-137-237</a></li>
					<li><a href="https://www.facebook.com/profile.php?id=100095697124318" target="_blank" class="text-primary" title="Facebook"><i class="fab fa-facebook-f"></i></a></li>
					<li><a href="https://x.com/PPRAPakistan" target="_blank" class="text-primary"><img src="./assets/images/twitterx.png" title="X"></a></li>
					<li class="pr-0"><a [routerLink]="['/contactus']" class="text-dark" title="Contact us"><i class="far fa-envelope"></i></a></li> -->
          <!-- <li class="register"><a [href]="this.userUtilsService.selectedEnvironment?.authRegister" target="_blank">Register as a Supplier</a></li> -->
          <ng-container *ngIf="!isLoggedIn">
            <div>
              <li class="register ml-2"><a [href]="this.userUtilsService.selectedEnvironment?.authLogin"
                  target="_blank">EPADS Login</a></li>

              <li class="register ml-2">
                <a href="#/tenders/activetenders">
                  <i class="fas fa-search"></i> Tender Search
                </a>
              </li>
            </div>
            <div style="margin-top: 10px;">

              <a class="online-link" [href]="this.userUtilsService.selectedEnvironment?.authLogin2">Login for Online
                Tender Submission</a>
            </div>
          </ng-container>


          <ng-container *ngIf="isLoggedIn">

            <li class="login dropdown">
              <a href="#" class="dropdown-toggle" role="button" id="dropdownlogin" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">Welcome, {{ userName }}</a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownlogin">
                <a class="dropdown-item" href="#/user-management/tender"><i class="fas fa-file-alt mr-2"></i> My
                  Tenders</a>
                <a class="dropdown-item" href="#/user-management/password"><i class="fas fa-key mr-2"></i> Change
                  Password</a>
                <a class="dropdown-item" href="#" (click)="logout()"><i class="fas fa-sign-out-alt mr-2"></i> Logout</a>
              </div>
            </li>
          </ng-container>

        </ul>
      </div>
    </div>
  </div>

</header>
<div *ngIf="isPopupVisible" class="popup">
  <div class="popup-content">
    <span class="close" (click)="closePopup()">&times;</span>
    <h4>Website Under Maintenance</h4>
    <p>We are currently working on updates. Please check back later.</p>
  </div>
</div>